var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#chevron_right_black_svg__8g3p1aw0ya)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.171 10.838a1.162 1.162 0 00-1.645 0L14 15.365l-4.527-4.527a1.162 1.162 0 00-1.645 0 1.162 1.162 0 000 1.645l5.355 5.355c.455.455 1.19.455 1.645 0l5.355-5.355a1.173 1.173 0 00-.012-1.645z",
    fill: "#CCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "chevron_right_black_svg__8g3p1aw0ya"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(90 14 14)",
    d: "M0 0h28v28H0z"
  })))));
}
export default SvgChevronRightBlack;